module.exports = __webpack_public_path__ + "static/media/es.90559fc5.svg";